export const environment = {
  mode: 'dev',
  production: true,
  hmr: false,
  apiUrl: 'https://devserver.mrpro.cloud',
  debugTranslation: false,
  baseheader: 'TVIucHJvX0Jhc2VfMjAyNl9BZG1pbjpFVi5yOUghYjQzbT4xeCl0UD46a3VjV0RVN3BjOS4=',
  okta: {
    redirectUri: 'https://dev.mrpro.cloud/login/callback',
    logoutUri: 'https://dev.mrpro.cloud/',
    clientId: '0oacbgbmmwKUoXtwt0i7',
    domain: 'login.vossloh-digital.com',
    showLogin: true,
  },
  msalConfig: {
    redirectUri: 'https://dev.mrpro.cloud/login',
    showLogin: true,
  },
};
